/* eslint-disable react/jsx-no-useless-fragment */

import React, { useEffect, useState } from 'react';

import {
  Container,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Snackbar,
  Alert,
  Dialog,
  LinearProgress,
  IconButton,
  Collapse,
  Chip,
  Box,
  DialogTitle,
  DialogContent
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import XLSXS from 'xlsx-js-style';
import moment from 'moment'
import styled from '@emotion/styled';
import DownloadIcon from '@mui/icons-material/Download';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';


// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const formatDateToinitialValues = (date) => {
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const currentDate = new Date();
const fromDateOnCurrentMonth = new Date(currentDate);
fromDateOnCurrentMonth.setDate(1);
const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
const initialToDate = formatDateToinitialValues(currentDate);

const ManpowerReport = () => {
  const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const today = new Date().toISOString().split('T')[0];
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [expanded, setExpanded] = useState(true);
  const [openLoader, setOpenLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [message, setMessage] = useState('');
  const [tableData, setTableData] = useState([]);
  const [processList, setProcessList] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [attendanceFilter, setAttendanceFilter] = useState('Present');
  const [minimized, setMinimized] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedProcessName, setSelectedProcessName] = useState('');

  const [popupLoading, setPopupLoading] = useState(false);
  const [selectedLines, setSelectedLines] = useState({});

  useEffect(() => {
    GetAllActiveProductionUnits();
  }, []);

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const isMoreThanOneMonth = (from, to) => {
    if (!from || !to) return false;

    const fromDateObj = new Date(from);
    const toDateObj = new Date(to);

    const diffTime = toDateObj.getTime() - fromDateObj.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays > 31;
  };

  const applyFilters = async () => {
    try {

      if (isMoreThanOneMonth(fromDate, toDate)) {
        setMessage('You cannot select more than 1 month date range');
        setShowSnackbar(true);
        return;
      }

      setOpenLoader(true);

      const payload = {
        FromDate: fromDate,
        ToDate: toDate,
        processId: 0,
        Unit_Id: unitSelected.Unit_Id,
      };

      const res = await axios.instance.post(
        '/GetManpower',
        payload,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      if (res.data?.length > 0) {
        setTableData(res.data);
      } else {
        setTableData([]);
      }
      setOpenLoader(false);
    } catch (error) {
      console.error(error);
      setOpenLoader(false);
    }
  };

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);

    setUnitSelected({
      Unit_Id: '0',
      Unit_Name: 'All',
    });
    setTableData([]);
    setProcessList([]);
    setExpanded(true);
  };

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };


  const handleExpansion = () => {
    setExpanded(!expanded);
  };


  const handleExportExcel = () => {
    if (!tableData || tableData.length === 0) return;

    const wb = XLSXS.utils.book_new();

    const title = 'Manpower Report';
    const DateStr = moment().format('DD-MM-YYYY');

    const headers = [
      'S.No',
      'Month',
      'Process Name',
      'No.of.Employee',
      'Values',
    ];

    const data = tableData.map((row, index) => ({
      'S.No': index + 1,
      'Month': moment(fromDate).format('MMMM YYYY'),
      'Process Name': row.ProcessName || '',
      'No.of.Employee': row.EmployeeCount || 0,
      'Values': Number(row.TotalValue || 0),
    }));

    const totalEmployees = tableData.reduce(
      (sum, row) => sum + Number(row.EmployeeCount || 0),
      0
    );

    const totalValue = tableData.reduce(
      (sum, row) => sum + Number(row.TotalValue || 0),
      0
    );

    // TOTAL row
    data.push({
      'S.No': '',
      'Month': '',
      'Process Name': 'TOTAL',
      'No.of.Employee': totalEmployees,
      'Values': totalValue.toFixed(2),
    });

    const startRow = 5;

    const ws = XLSXS.utils.json_to_sheet(data, {
      origin: `A${startRow}`,
      header: headers,
    });

    // Title
    ws.A1 = {
      v: title,
      t: 's',
      s: {
        font: { bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: '219C90' } },
      },
    };

    ws.A2 = {
      v: `Generated on: ${moment().format('DD-MM-YYYY HH:mm:ss')}`,
      t: 's',
    };

    // Merge title + Month column merge
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },

      {
        s: { r: startRow, c: 1 },
        e: { r: startRow + tableData.length - 1, c: 1 },
      }
    ];

    // Header styling
    const headerRow = startRow - 1;

    headers.forEach((h, i) => {
      const cell = XLSXS.utils.encode_cell({ r: headerRow, c: i });
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '134E5E' } },
          alignment: { horizontal: 'center' },
        };
      }
    });
    const monthCell = XLSXS.utils.encode_cell({
      r: startRow,
      c: 1,
    });

    if (ws[monthCell]) {
      ws[monthCell].s = {
        alignment: {
          vertical: 'center',
          horizontal: 'center',
        },
        font: { bold: true },
      };
    }

    ws['!cols'] = [
      { wch: 8 },
      { wch: 18 },
      { wch: 25 },
      { wch: 18 },
      { wch: 15 },
    ];


    const totalRowIndex = startRow + data.length - 1;

    const totalLabelCell = XLSXS.utils.encode_cell({
      r: totalRowIndex,
      c: 2,
    });

    ws[totalLabelCell] = {
      v: 'TOTAL',
      t: 's',
      s: {
        font: { bold: true },
        alignment: { horizontal: 'right' },
      },
    };

    XLSXS.utils.book_append_sheet(wb, ws, title);

    XLSXS.writeFile(
      wb,
      `${title.replace(/ /g, '_')}_${DateStr}.xlsx`
    );
  };

  const handleOpenPopup = async (row) => {

    try {
      setOpenLoader(true);
      setSelectedRow(row);
      setSelectedProcessName(row.ProcessName);
      const defaultAttendance = 'Present';
      setAttendanceFilter(defaultAttendance);
      const payload = {
        FromDate: fromDate,
        ToDate: toDate,
        ProcessId: row.ProcessId || 0,
        DepartmentId: unitSelected.Unit_Id || 0,
        AttendanceType: defaultAttendance
      };
      const res = await axios.instance.post(
        '/GetManpowerPopupReport',
        payload,
        {
          headers: {
            Authorization: token
          }
        }
      );
      setPopupData(res.data || []);
      setOpenPopup(true);
    } catch (err) {
      console.error(err);
    } finally {
      setOpenLoader(false);
    }
  };

  const loadPopupData = async (type) => {
    try {
      setOpenLoader(true);
      setPopupLoading(true);
      const payload = {
        FromDate: fromDate,
        ToDate: toDate,
        ProcessId: selectedRow?.ProcessId || 0,
        DepartmentId: unitSelected.Unit_Id || 0,
        AttendanceType: type
      };
      const res = await axios.instance.post(
        '/GetManpowerPopupReport',
        payload,
        {
          headers: {
            Authorization: token
          }
        }
      );
      setPopupData(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setOpenLoader(false);
      setPopupLoading(false);
    }
  };

  const groupByDate = (data) => {
    return data.reduce((acc, item) => {
      const date = item.WorkDate?.split('T')[0];

      if (!acc[date]) acc[date] = [];
      acc[date].push(item);

      return acc;
    }, {});
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ pt: 2 }}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="info"
            variant="filled"
            sx={{ width: '100%' }}
          >
            {message}
          </Alert>
        </Snackbar>

        {/* TITLE */}

        <Typography
          variant="h5"
          sx={{
            p: 1.5,
            mb: 2,
            textAlign: 'center',
            borderRadius: 2,
            color: 'white',
            background: 'linear-gradient(to right, #134e5e, #71b280)',
          }}
        >
          Manpower Report
        </Typography>

        {/* FILTERS */}

        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{
              borderTop: 'none',
              borderColor: 'black',
              backgroundColor: 'inherit',
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack
                justifyContent="start"
                direction="row"
                alignItems="center"
                spacing={1}
              >
                <IconButton
                  aria-label="filter-icon"
                  sx={{
                    p: 0.5,
                  }}
                >
                  <MastersIcon
                    style={{
                      width: 22,
                      height: 22,
                    }}
                  />
                </IconButton>

                <Typography
                  variant="h6"
                  sx={{
                    color: '#36BA98',
                    fontWeight: 'bold',
                  }}
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 5 }}>

              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="From Date"
                        type="date"
                        value={fromDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setfromDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="To Date"
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    {/* Factory Selector */}
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Factory</InputLabel>
                        <Select
                          value={unitSelected.Unit_Id}
                          label="Select Factory"
                          onChange={(e) => {
                            const selectedUnit = unitData.find(unit => unit.Unit_Id.toString() === e.target.value) || { Unit_Id: '0', Unit_Name: 'All' };
                            setUnitSelected(selectedUnit);
                          }}
                        >
                          <MenuItem value="0">All</MenuItem>
                          {unitData.map((unit) => (
                            <MenuItem key={unit.Unit_Id} value={unit.Unit_Id.toString()}>
                              {unit.Unit_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Stack>
                <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'flex-end'}>
                  <Stack direction={'row'} spacing={1}>
                    <Button variant="contained" color="secondary" onClick={applyFilters} startIcon={<FilterAltIcon />}>
                      Apply Filters
                    </Button>
                    <Button variant="contained" color="warning" onClick={resetFilters} startIcon={<LockResetIcon />}>
                      reset
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      size="medium"
                      startIcon={<DownloadIcon />}
                      onClick={handleExportExcel}
                    >
                      Export Excel
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        {/* TABLE */}
        <Collapse in={tableData.length > 0}>
          <>
            <TableContainer
              sx={{
                borderRadius: 1,
                backgroundColor: 'inherit',
                maxWidth: '1000px',
                margin: 'auto',
              }}
              elevation={4}
              component={Paper}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="center">Month</StyledTableCell>
                    <StyledTableCell align="left">Process Name</StyledTableCell>
                    <StyledTableCell align="center">No.of.Employee</StyledTableCell>
                    <StyledTableCell align="right">Values</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell align="center">{index + 1}</TableCell>
                      {index === 0 && (
                        <TableCell
                          align="center"
                          rowSpan={tableData.length}
                          sx={{
                            verticalAlign: 'middle',
                            fontWeight: 'bold',
                            color: '#134e5e',
                          }}
                        >
                          {moment(fromDate).format('MMMM YYYY')}
                        </TableCell>
                      )}
                      <TableCell align="left">{row.ProcessName}</TableCell>
                      <TableCell align="center" sx={{ cursor: 'pointer' }}
                        onClick={() => handleOpenPopup(row)}
                      >
                        {row.EmployeeCount
                          ? Number(row.EmployeeCount).toLocaleString('en-IN', {
                          })
                          : '0.00'}</TableCell>
                      <TableCell align="right">
                        {row.TotalValue
                          ? Number(row.TotalValue).toLocaleString('en-IN', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })
                          : '0.00'}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow
                    sx={{
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    <TableCell colSpan={2} />
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: 'bold',
                        color: '#219C90',
                      }}
                    >
                      Total
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: 'bold',
                        color: '#219C90',
                      }}
                    >
                      {tableData
                        .reduce((sum, row) => sum + Number(row.EmployeeCount || 0), 0)
                        .toLocaleString('en-IN')}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 'bold',
                        color: '#219C90',
                      }}
                    >
                      {tableData
                        .reduce((sum, row) => sum + Number(row.TotalValue || 0), 0)
                        .toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </>
        </Collapse>
      </Container>

      <Dialog
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        fullWidth
        maxWidth="lg"
        hideBackdrop={minimized}
        PaperProps={{
          sx: {
            borderRadius: 3,
            height: minimized ? '60px' : 'auto',
            overflow: 'hidden',
            position: 'fixed',
            bottom: minimized ? 16 : 'auto',
            right: minimized ? 16 : 'auto',
            margin: minimized ? 0 : 'auto',
            width: minimized ? '600px' : '100%',
            maxWidth: minimized ? '700px' : 'md'
          }
        }}
      >
        {/* HEADER */}
        <DialogTitle
          sx={{
            backgroundColor: '#219C90',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 16px'
          }}
        >
          <Typography
            fontWeight="bold"
            sx={{
              fontSize: '14px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '70%'
            }}
          >
            Attendance Details - {selectedProcessName}
            {' | '}
            {moment(fromDate).format('DD-MM-YYYY')}
            {' → '}
            {moment(toDate).format('DD-MM-YYYY')}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            {/* PRESENT */}
            <Button
              size="small"
              variant={
                attendanceFilter === 'Present'
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => {
                setSelectedLines({});
                setAttendanceFilter('Present');
                loadPopupData('Present');
              }}
              sx={{
                minWidth: 80,
                fontSize: '11px',
                height: 28,
                bgcolor:
                  attendanceFilter === 'Present'
                    ? '#fff'
                    : 'transparent',
                color:
                  attendanceFilter === 'Present'
                    ? '#219C90'
                    : '#fff',
                borderColor: '#fff',
                '&:hover': {
                  bgcolor: '#e0f2f1'
                }
              }}
            >
              Present
            </Button>

            {/* ABSENT */}
            <Button
              size="small"
              variant={
                attendanceFilter === 'Absent'
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => {
                setSelectedLines({});
                setAttendanceFilter('Absent');
                loadPopupData('Absent');
              }}
              sx={{
                minWidth: 80,
                fontSize: '11px',
                height: 28,
                bgcolor:
                  attendanceFilter === 'Absent'
                    ? '#fff'
                    : 'transparent',
                color:
                  attendanceFilter === 'Absent'
                    ? '#219C90'
                    : '#fff',
                borderColor: '#fff',
                '&:hover': {
                  bgcolor: '#e0f2f1'
                }
              }}
            >
              Absent
            </Button>

            {/* CLOSE */}
            <IconButton
              onClick={() => setOpenPopup(false)}
              size="small"
              sx={{
                color: 'white',
                '&:hover': {
                  backgroundColor: '#e53935'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* BODY */}
        {!minimized && (
          <DialogContent
            sx={{
              p: 1,
              backgroundColor: '#f5f5f5'
            }}
          >
            {popupLoading ? (
              <Box
                sx={{
                  height: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress sx={{ color: '#219C90' }} />
              </Box>
            ) : (
              <Box
                sx={{
                  maxHeight: '65vh',
                  overflowY: 'auto'
                }}
              >
                {popupData && popupData.length > 0 ? (
                  Object.entries(groupByDate(popupData)).map(([date, rows], idx) => {

                    const filteredRows = rows;

                    const totalPerDay = filteredRows.reduce(
                      (sum, r) =>
                        sum + Number(r.PerDaySalary || 0),
                      0
                    );

                    const groupedByLine = filteredRows.reduce((acc, item) => {

                      const lineName = item.Line_Name || 'No Line';

                      if (!acc[lineName]) {
                        acc[lineName] = [];
                      }

                      acc[lineName].push(item);

                      return acc;

                    }, {});

                    const getDefaultLine = (groupedByLine) => {

                      const orderedLines = [
                        'Line A',
                        'Line B',
                        'Line C',
                        'Line D',
                        'Line E',
                        'Line F',
                        'Line G',
                        'Line H',
                        'Line I',
                        'Line J'
                      ];

                      return (
                        orderedLines.find(
                          (line) =>
                            groupedByLine[line]?.length > 0
                        ) ||
                        Object.keys(groupedByLine)[0]
                      );
                    };

                    const availableLines = Object.keys(groupedByLine)
                      .filter(
                        (line) =>
                          groupedByLine[line]?.length > 0
                      )
                      .sort();

                    const selectedLine =
                      selectedLines[date] ||
                      getDefaultLine(groupedByLine);

                    const employees =
                      groupedByLine[selectedLine] || [];

                    return (
                      <Box key={idx} sx={{ mb: 3 }}>

                        {/* DATE */}
                        <Typography
                          sx={{
                            fontWeight: 'normal',
                            fontSize: '14px',
                            mb: 1,
                            color: '#1976d2'
                          }}
                        >
                          Date : {moment(date).format('DD-MM-YYYY')}
                        </Typography>

                        {/* LINE TOGGLES */}
                        {selectedProcessName === 'Production' && (
                          <Box
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 1,
                              mb: 1
                            }}
                          >
                            {availableLines.map((line) => (
                              <Button
                                key={line}
                                size="small"
                                variant={
                                  selectedLine === line
                                    ? 'contained'
                                    : 'outlined'
                                }
                                onClick={() =>
                                  setSelectedLines((prev) => ({
                                    ...prev,
                                    [date]: line
                                  }))
                                }
                                sx={{
                                  minWidth: 85,
                                  height: 30,
                                  fontSize: '11px',
                                  textTransform: 'none',
                                  borderRadius: '20px',
                                  boxShadow: 'none',
                                  fontWeight: 600,
                                  bgcolor:
                                    selectedLine === line
                                      ? '#219C90'
                                      : '#fff',
                                  color:
                                    selectedLine === line
                                      ? '#fff'
                                      : '#219C90',
                                  borderColor: '#219C90',
                                  '&:hover': {
                                    bgcolor:
                                      selectedLine === line
                                        ? '#19796f'
                                        : '#e0f2f1',
                                    borderColor: '#219C90'
                                  }
                                }}
                              >
                                {line}
                              </Button>
                            ))}
                          </Box>
                        )}

                        {/* TABLE */}
                        <Box
                          sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            boxShadow: 2
                          }}
                        >
                          <table
                            style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              fontSize: '12px'
                            }}
                          >
                            <thead
                              style={{
                                backgroundColor: '#e3f2fd'
                              }}
                            >
                              <tr>
                                <th style={{ padding: '6px 8px', textAlign: 'left' }}>
                                  S.No
                                </th>

                                <th style={{ padding: '6px 8px', textAlign: 'left' }}>
                                  Employee Name
                                </th>

                                <th style={{ padding: '6px 8px', textAlign: 'left' }}>
                                  Designation
                                </th>

                                <th style={{ padding: '6px 8px', textAlign: 'right' }}>
                                  Salary
                                </th>

                                <th style={{ padding: '6px 8px', textAlign: 'right' }}>
                                  Per Day
                                </th>
                              </tr>
                            </thead>

                            <tbody>

                              {selectedProcessName === 'Production' ? (

                                employees.map((r, i) => (
                                  <tr
                                    key={i}
                                    style={{
                                      backgroundColor:
                                        i % 2 === 0
                                          ? '#fff'
                                          : '#f9f9f9'
                                    }}
                                  >
                                    <td style={{ padding: '6px 8px' }}>
                                      {i + 1}
                                    </td>

                                    <td style={{ padding: '6px 8px' }}>
                                      {r.UserCode} - {r.UserName}
                                    </td>

                                    <td style={{ padding: '6px 8px' }}>
                                      {r.DepartmentDescription}
                                    </td>

                                    <td
                                      style={{
                                        padding: '6px 8px',
                                        textAlign: 'right'
                                      }}
                                    >
                                      {Number(r.Salary).toLocaleString('en-IN')}
                                    </td>

                                    <td
                                      style={{
                                        padding: '6px 8px',
                                        textAlign: 'right'
                                      }}
                                    >
                                      {Number(
                                        r.PerDaySalary
                                      ).toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </td>
                                  </tr>
                                ))

                              ) : (

                                filteredRows.map((r, i) => (
                                  <tr
                                    key={i}
                                    style={{
                                      backgroundColor:
                                        i % 2 === 0
                                          ? '#fff'
                                          : '#f9f9f9'
                                    }}
                                  >
                                    <td style={{ padding: '6px 8px' }}>
                                      {i + 1}
                                    </td>

                                    <td style={{ padding: '6px 8px' }}>
                                      {r.UserCode} - {r.UserName}
                                    </td>

                                    <td style={{ padding: '6px 8px' }}>
                                      {r.DepartmentDescription}
                                    </td>

                                    <td
                                      style={{
                                        padding: '6px 8px',
                                        textAlign: 'right'
                                      }}
                                    >
                                      {Number(r.Salary).toLocaleString('en-IN')}
                                    </td>

                                    <td
                                      style={{
                                        padding: '6px 8px',
                                        textAlign: 'right'
                                      }}
                                    >
                                      {Number(
                                        r.PerDaySalary
                                      ).toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </td>
                                  </tr>
                                ))

                              )}

                              {/* TOTAL */}
                              <tr style={{ fontWeight: 'bold' }}>
                                <td
                                  colSpan={4}
                                  style={{
                                    padding: '6px 8px',
                                    backgroundColor: '#d0d0d0'
                                  }}
                                >
                                  Total
                                </td>

                                <td
                                  style={{
                                    padding: '6px 8px',
                                    textAlign: 'right',
                                    backgroundColor: '#d0d0d0'
                                  }}
                                >
                                  {Number(totalPerDay).toLocaleString(
                                    'en-IN',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  )}
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      height: '300px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#777',
                      fontWeight: 500
                    }}
                  >
                    No Data Found
                  </Box>
                )}

                {/* GRAND TOTAL */}
                <Box
                  sx={{
                    padding: '10px',
                    backgroundColor: '#219C90',
                    borderRadius: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: 'white'
                  }}
                >
                  <Typography fontWeight="bold">
                    Grand Total
                  </Typography>

                  <Typography fontWeight="bold">
                    {popupData
                      .reduce(
                        (sum, r) =>
                          sum + Number(r.PerDaySalary || 0),
                        0
                      )
                      .toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                  </Typography>
                </Box>
              </Box>
            )}
          </DialogContent>
        )}
      </Dialog>
    </>
  );
};

export default ManpowerReport;